/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

//this is a inner message bus
var Slots = {};
var MsgBus = {};
MsgBus.Sub = function (topic, cb) {
    if (typeof cb !== 'function') {
        // eslint-disable-next-line
        console.log("cant sub topic ,because cb is not a function(topic,data)");
        return;
    }

    if (typeof Slots[topic] === 'undefined') {
        Slots[topic] = {};
    }
    var id = _scope.Utils.Guid();
    Slots[topic][id] = cb;
    return { id: id, topic: topic };
};

MsgBus.On = function (topic, cb) {
    return MsgBus.Sub.call(this, topic, cb);
};

MsgBus.OnMultiOnce = function (topicArr, cb) {
    var _self = this;
    var hasDoneCount = 0;
    if (topicArr instanceof Array) {
        var maxLen = topicArr.length;
        topicArr.map(function (topic) {
            var cancelKey = MsgBus.Sub.call(_self, topic, function () {
                hasDoneCount++;
                MsgBus.UnSub(cancelKey);
                if (hasDoneCount == maxLen) {
                    typeof cb === 'function' && cb();
                }
            });
        });
    }
};

MsgBus.Pub = function (topic, data) {
    // eslint-disable-next-line
    // window.MUDUDEBUG && console.log && console.log("mudubus log ", topic, data);
    if (typeof Slots[topic] === 'undefined') {
        return;
    }
    for (var id in Slots[topic]) {
        Slots[topic][id](data, topic);
    }
};
MsgBus.UnSub = function (key) {
    if (typeof Slots[key.topic] === 'undefined') {
        return;
    }
    if (typeof Slots[key.topic][key.id] === 'undefined') {
        return;
    }
    delete Slots[key.topic][key.id];
};

MsgBus.UnSubAll = function (topic) {
    delete Slots[topic];
};

MsgBus.Clear = function () {
    Slots = {};
};

module.exports = MsgBus;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/modules/MsgBus.js
 ** module id = 23
 ** module chunks = 1
 **/